import { render, staticRenderFns } from "./RegionSummary.vue?vue&type=template&id=1bd9fe11&"
import script from "./RegionSummary.vue?vue&type=script&lang=js&"
export * from "./RegionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd9fe11')) {
      api.createRecord('1bd9fe11', component.options)
    } else {
      api.reload('1bd9fe11', component.options)
    }
    module.hot.accept("./RegionSummary.vue?vue&type=template&id=1bd9fe11&", function () {
      api.rerender('1bd9fe11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/RegionSummary.vue"
export default component.exports